<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length == 0"
        @click="deleteAttributeCategory"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="editAttributeCategory"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? this.$t('dialog.titleAttributeCategoryUpdate')
          : this.$t('dialog.titleAttributeCategoryAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Mã danh mục">
                  <div class="das-form-input">
                    <div class="label required">Mã danh mục:</div>
                    <div class="child-w-80">
                      <input
                        v-model="attributeCatItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Việt:</div>
                    <div class="child-w-80">
                      <input v-model="attributeCatItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Anh:</div>
                    <div class="child-w-80">
                      <input v-model="attributeCatItem.eng_name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Loại dịch vụ">
                  <div class="das-form-input">
                    <div class="label required">Loại dịch vụ:</div>
                    <select-with-search-table
                      style="width: 100%"
                      :rows="serviceTypeOptions"
                      :columns="selectSearchCol2"
                      :value="attributeCatItem.service_type_id"
                      :selected-index-field-value="
                        attributeCatItem.service_type_id
                      "
                      index-field="id"
                      @selectionChanged="onSelectRowOption2"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.code }}
                      </template>
                    </select-with-search-table>
                    <!-- <div class="child-w-80">
                      <select v-model="attributeCatItem.service_type_id">
                        <option
                          v-for="item in serviceTypeOptions"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.desc }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="attributeCatItem.allow_mul_attr"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">Cho phép chọn nhiều thuộc tính</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateAttributeCategory"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small"
            @click="addAttributeCategory"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListAttributeCategoryApi,
  addAttributeCategoryApi,
  updateAttributeCategoryApi,
  deleteAttributeCategoryApi
} from '@/api/configuration/accounting/product/attributeCategory.js'
import { getServiceTypeListApi } from '@/api/common/code'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      selectedRows: [],
      selectSearchCol2: [
        {
          headerName: 'Loại dịch vụ',
          field: 'code',
          flex: 1
        }
      ],
      serviceTypeOptions: [],
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã danh mục',
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name'
        },
        {
          headerName: 'Loại dịch vụ',
          field: 'service_type_code',
          tooltipField: 'service_type_code'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      attributeCatItem: {
        code: null,
        name: '',
        eng_name: '',
        service_type_id: null,
        service_type_code: '',
        service_type_desc: '',
        order: null,
        allow_mul_attr: true
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    const res = await getServiceTypeListApi()
    this.serviceTypeOptions = res.data
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onSelectRowOption2(val) {
      this.attributeCatItem.service_type_id = val.id
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.attributeCatItem = {
        code: null,
        name: '',
        eng_name: '',
        service_type_id: null,
        service_type_code: '',
        service_type_desc: '',
        order: null,
        allow_mul_attr: true
      }
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addAttributeCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addAttributeCategoryApi(this.attributeCatItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editAttributeCategory() {
      const row = this.selectedRows[0]
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.attributeCatItem, row)
    },
    async deleteAttributeCategory() {
      const ids = this.selectedRows.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteAttributeCategoryConfirm'), () => {
        deleteAttributeCategoryApi({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateAttributeCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      this.attributeCatItem.id = this.rowsSelected[0].id
      let data = await updateAttributeCategoryApi(this.attributeCatItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListAttributeCategoryApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>
